import React, { useState } from "react";

const GenderSection = ({ gender, setGender }) => {
  const [editMode, setEditMode] = useState(false);

  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };

  const handleEditMode = () => {
    setEditMode(true);
  };

  const handleCancel = () => {
    setEditMode(false);
  };

  const handleSave = () => {
    setEditMode(false);
  };

  return (
    <div className="mb-4">
      <h2 className="font-bold text-gray-700 text-lg mb-2">Gender</h2>
      {editMode ? (
        <div className="mt-2">
          <select
            className="w-full border-gray-300 rounded-md shadow-sm mb-2"
            value={gender}
            onChange={handleGenderChange}
          >
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Non-binary">Non-binary</option>
          </select>
          <div className="flex justify-end">
            <button
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-l"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded-r"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      ) : (
        <div className="items-center justify-between">
          <p className="text-gray-500 text-sm">{gender}</p>
          <button
            className="text-blue-500 hover:text-blue-700 text-sm"
            onClick={handleEditMode}
          >
            Edit
          </button>
        </div>
      )}
    </div>
  );
};

export default GenderSection;
